module.exports = __webpack_public_path__ + "images/connect-right-d53058f843bf7071f1859f89639782c1.png";